import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { BasicTooltip, Icon, palette } from '@livable/saas-react-components';
import { Box, Button, IconButton, Menu, MenuItem, Skeleton, Typography } from '@mui/material';
import { useStore } from 'src/stores';
import { ALL_SUBSCRIPTIONS_PAGE_SIZE, SUBSCRIPTION_STATUS_CANCELED } from '../../initialState';
import { formatScheduleDate, formatScheduleTime, formatScheduleTimestampDate } from '../scheduleChangeDates';
import { SCHEDULE_CHANGE_SCHEDULABLE_STATUSES, getScheduleChangeSubscriptionId } from '../scheduleChangeTypes';
import { SCHEDULE_CHANGE_TYPES, ScheduleChangeModal, getScheduleChangeTypeConfig } from '../ScheduleChangeModal';
import useStyles from './styles';
const KEY_PREFIX = 'subscriptions.scheduleChange';
const INITIAL_STATE = {
  menuAnchor: null,
  openType: '',
  changeBeingEdited: null,
  changeBeingRemoved: '',
  removedChangeIds: [],
  isSyncing: false,
  syncingChangeId: ''
};
const toScheduledChange = raw => {
  var _raw$id, _raw$type, _raw$effectiveFrom, _raw$effectiveUntil, _raw$reason, _raw$createdAt, _raw$createdBy, _raw$createdByFullnam;
  return {
    id: (_raw$id = raw.id) !== null && _raw$id !== void 0 ? _raw$id : '',
    type: (_raw$type = raw.type) !== null && _raw$type !== void 0 ? _raw$type : '',
    effectiveFrom: (_raw$effectiveFrom = raw.effectiveFrom) !== null && _raw$effectiveFrom !== void 0 ? _raw$effectiveFrom : '',
    effectiveUntil: (_raw$effectiveUntil = raw.effectiveUntil) !== null && _raw$effectiveUntil !== void 0 ? _raw$effectiveUntil : null,
    reason: (_raw$reason = raw.reason) !== null && _raw$reason !== void 0 ? _raw$reason : null,
    createdAt: (_raw$createdAt = raw.createdAt) !== null && _raw$createdAt !== void 0 ? _raw$createdAt : '',
    createdBy: (_raw$createdBy = raw.createdBy) !== null && _raw$createdBy !== void 0 ? _raw$createdBy : '',
    createdByFullname: (_raw$createdByFullnam = raw.createdByFullname) !== null && _raw$createdByFullnam !== void 0 ? _raw$createdByFullnam : null
  };
};
export const UpcomingChanges = observer(function UpcomingChanges(_ref) {
  var _store$stripe$subscri, _ref2, _liveRow$scheduledCha, _ref3, _ref4, _liveRow$companyName, _liveRow$term, _liveRow$startDate, _liveRow$commitmentEn, _liveRow$activeUnitsC;
  let subscription = _ref.subscription,
    statusOverride = _ref.statusOverride;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(INITIAL_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  const subscriptionId = getScheduleChangeSubscriptionId(subscription);
  const liveRow = ((_store$stripe$subscri = store.stripe.subscriptionsPaged) !== null && _store$stripe$subscri !== void 0 ? _store$stripe$subscri : []).find(row => row.id === subscriptionId);
  const rawChanges = ((_ref2 = (_liveRow$scheduledCha = liveRow === null || liveRow === void 0 ? void 0 : liveRow.scheduledChanges) !== null && _liveRow$scheduledCha !== void 0 ? _liveRow$scheduledCha : subscription.scheduledChanges) !== null && _ref2 !== void 0 ? _ref2 : []).map(raw => toScheduledChange(raw)).filter(change => {
    var _state$removedChangeI;
    return !((_state$removedChangeI = state.removedChangeIds) !== null && _state$removedChangeI !== void 0 ? _state$removedChangeI : []).includes(change.id);
  });
  const status = (_ref3 = (_ref4 = statusOverride !== null && statusOverride !== void 0 ? statusOverride : liveRow === null || liveRow === void 0 ? void 0 : liveRow.status) !== null && _ref4 !== void 0 ? _ref4 : subscription.status) !== null && _ref3 !== void 0 ? _ref3 : '';
  const canCancel = SCHEDULE_CHANGE_SCHEDULABLE_STATUSES.includes(status);
  const isButtonDisabled = !canCancel;
  const disabledTooltipKey = status === SUBSCRIPTION_STATUS_CANCELED ? 'schedule_disabled_canceled_tooltip' : 'schedule_disabled_tooltip';
  const modalSubscription = {
    id: subscriptionId,
    companyName: (_liveRow$companyName = liveRow === null || liveRow === void 0 ? void 0 : liveRow.companyName) !== null && _liveRow$companyName !== void 0 ? _liveRow$companyName : subscription.companyName,
    term: (_liveRow$term = liveRow === null || liveRow === void 0 ? void 0 : liveRow.term) !== null && _liveRow$term !== void 0 ? _liveRow$term : subscription.term,
    startDate: (_liveRow$startDate = liveRow === null || liveRow === void 0 ? void 0 : liveRow.startDate) !== null && _liveRow$startDate !== void 0 ? _liveRow$startDate : subscription.startDate,
    commitmentEndDate: (_liveRow$commitmentEn = liveRow === null || liveRow === void 0 ? void 0 : liveRow.commitmentEndDate) !== null && _liveRow$commitmentEn !== void 0 ? _liveRow$commitmentEn : subscription.commitmentEndDate,
    activeUnitsCount: (_liveRow$activeUnitsC = liveRow === null || liveRow === void 0 ? void 0 : liveRow.activeUnitsCount) !== null && _liveRow$activeUnitsC !== void 0 ? _liveRow$activeUnitsC : subscription.activeUnitsCount
  };
  const pendingTypes = new Set(rawChanges.map(change => change.type));
  const menuTypes = Object.keys(SCHEDULE_CHANGE_TYPES).filter(type => {
    const config = SCHEDULE_CHANGE_TYPES[type];
    return !config.allowsOnlyOnePending || !pendingTypes.has(type);
  });
  const isTypeEnabled = config => config.isEnabled && (!config.requiresActiveSubscription || canCancel);
  const getBadgeStyle = function (config) {
    let isEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return config.badgeColor ? {
      backgroundColor: config.badgeColor,
      color: isEnabled ? config.badgeIconColor : palette.shades[500]
    } : undefined;
  };
  const refreshSubscriptions = () => store.stripe.getSubscriptionsLoadAllAsync.run({
    pageSize: ALL_SUBSCRIPTIONS_PAGE_SIZE
  });
  const handleAddClick = event => {
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      menuAnchor: event.currentTarget
    }));
  };
  const handleMenuClose = () => {
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      menuAnchor: null
    }));
  };
  const handleModalClose = () => {
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      openType: '',
      changeBeingEdited: null
    }));
  };
  const handleScheduled = async () => {
    setState(prev => {
      var _prev$changeBeingEdit, _prev$changeBeingEdit2;
      return _objectSpread(_objectSpread({}, prev), {}, {
        isSyncing: true,
        syncingChangeId: (_prev$changeBeingEdit = (_prev$changeBeingEdit2 = prev.changeBeingEdited) === null || _prev$changeBeingEdit2 === void 0 ? void 0 : _prev$changeBeingEdit2.id) !== null && _prev$changeBeingEdit !== void 0 ? _prev$changeBeingEdit : ''
      });
    });
    await refreshSubscriptions();
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      isSyncing: false,
      syncingChangeId: ''
    }));
  };
  const createTypeSelectHandler = type => () => {
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      menuAnchor: null,
      openType: type,
      changeBeingEdited: null
    }));
  };
  const createRescheduleHandler = change => () => {
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      openType: change.type,
      changeBeingEdited: change
    }));
  };
  const createRevokeHandler = change => async () => {
    if (!subscriptionId || !change.id || state.changeBeingRemoved) return;
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      changeBeingRemoved: change.id
    }));
    await store.stripe.removeScheduledChangeAsync.run({
      subscriptionId,
      changeId: change.id
    }, []);
    const isError = store.stripe.removeScheduledChangeAsync.isError;
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      changeBeingRemoved: '',
      removedChangeIds: isError ? prev.removedChangeIds : [...prev.removedChangeIds, change.id]
    }));
    refreshSubscriptions();
  };
  const renderChange = change => {
    var _change$createdByFull, _change$createdByFull2;
    const config = getScheduleChangeTypeConfig(change.type);
    const effectiveFrom = formatScheduleDate(change.effectiveFrom);
    const effectiveDates = change.effectiveUntil ? "".concat(effectiveFrom, " \u2014 ").concat(formatScheduleDate(change.effectiveUntil)) : effectiveFrom;
    const creator = (_change$createdByFull = (_change$createdByFull2 = change.createdByFullname) === null || _change$createdByFull2 === void 0 ? void 0 : _change$createdByFull2.trim()) !== null && _change$createdByFull !== void 0 ? _change$createdByFull : '';
    const scheduledOnDate = formatScheduleTimestampDate(change.createdAt);
    const scheduledOnTime = formatScheduleTime(change.createdAt);
    const scheduledOn = scheduledOnDate && scheduledOnTime ? t("".concat(KEY_PREFIX, ".").concat(creator ? 'scheduled_on_tooltip_by' : 'scheduled_on_tooltip'), {
      date: scheduledOnDate,
      time: scheduledOnTime,
      name: creator
    }) : '';
    return /*#__PURE__*/React.createElement(BasicTooltip, {
      key: change.id || "".concat(change.type, "-").concat(change.effectiveFrom),
      title: scheduledOn,
      placement: "top"
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.item
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.itemIconTile
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.itemIconBadge,
      style: getBadgeStyle(config)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: config.icon
    }))), /*#__PURE__*/React.createElement(Box, {
      className: classes.itemMain
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.itemTitle
    }, [effectiveFrom, t(config.labelKey)].filter(Boolean).join(' — ')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.itemLine
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        bold: /*#__PURE__*/React.createElement("b", null)
      },
      i18nKey: config.effectKey,
      values: {
        date: effectiveDates
      }
    }))), /*#__PURE__*/React.createElement(Box, {
      className: classes.itemActions
    }, !!config.Content && /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      "aria-label": t("".concat(KEY_PREFIX, ".reschedule_action")),
      onClick: createRescheduleHandler(change)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit-pencil"
    })), /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      "aria-label": t("".concat(KEY_PREFIX, ".revoke_action")),
      disabled: state.changeBeingRemoved === change.id,
      onClick: createRevokeHandler(change)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    })))));
  };
  const renderMenuItem = type => {
    const config = SCHEDULE_CHANGE_TYPES[type];
    const isEnabled = isTypeEnabled(config);
    const descriptionKey = config.captionKey || config.menuDescriptionKey;
    const itemClasses = [classes.menuItem, !isEnabled && classes.menuItemDisabled].filter(Boolean).join(' ');
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: type,
      "aria-disabled": !isEnabled,
      disableRipple: !isEnabled,
      className: itemClasses,
      onClick: isEnabled ? createTypeSelectHandler(type) : undefined
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.menuIcon
    }, /*#__PURE__*/React.createElement(Icon, {
      type: config.icon
    })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.menuLabel
    }, t(config.labelKey)), !!descriptionKey && /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.menuCaption
    }, t(descriptionKey))));
  };
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.section
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.sectionTitle
  }, t("".concat(KEY_PREFIX, ".section_title"))), (rawChanges.length > 0 || state.isSyncing) && /*#__PURE__*/React.createElement(Box, {
    className: classes.list
  }, rawChanges.map(change => state.isSyncing && change.id === state.syncingChangeId ? /*#__PURE__*/React.createElement(Skeleton, {
    key: change.id,
    variant: "rounded",
    height: 68,
    className: classes.itemSkeleton
  }) : renderChange(change)), state.isSyncing && !state.syncingChangeId && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rounded",
    height: 68,
    className: classes.itemSkeleton
  })), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: isButtonDisabled ? t("".concat(KEY_PREFIX, ".").concat(disabledTooltipKey)) : '',
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    className: classes.scheduleButton,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }),
    disabled: isButtonDisabled,
    onClick: handleAddClick
  }, t("".concat(KEY_PREFIX, ".add_button"))))), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: state.menuAnchor,
    open: !!state.menuAnchor,
    onClose: handleMenuClose,
    disableAutoFocusItem: true,
    classes: {
      paper: classes.menuPaper
    },
    MenuListProps: {
      disablePadding: true
    }
  }, menuTypes.map(type => renderMenuItem(type))), /*#__PURE__*/React.createElement(ScheduleChangeModal, {
    isOpen: !!state.openType,
    onClose: handleModalClose,
    type: state.openType || undefined,
    subscription: modalSubscription,
    scheduledChange: state.changeBeingEdited,
    onScheduled: handleScheduled
  }));
});